import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { logout } from '../session/logout';
import type { RootState } from '../store';

type StickyNotesState = Readonly<{
  /** Blank notes created in this session that haven't been edited, recolored, or moved. */
  pristineIds: number[];
}>;

const initialState: StickyNotesState = { pristineIds: [] };

export const stickyNotesSlice = createSlice({
  name: 'stickyNotes',
  initialState,
  reducers: {
    addPristineId: (state, action: PayloadAction<number>) => {
      state.pristineIds.push(action.payload);
    },
    removePristineId: (state, action: PayloadAction<number>) => {
      const index = state.pristineIds.indexOf(action.payload);

      if (index !== -1) state.pristineIds.splice(index, 1);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { addPristineId, removePristineId } = stickyNotesSlice.actions;

export const selectIsStickyNotePristine = (id: number) => (state: RootState) =>
  state.stickyNotes.pristineIds.includes(id);
